












































































































































































































































import { Component, Vue } from "vue-property-decorator";
import alegaciones_loteModule from "@/store/modules/alegaciones_lote-module";
import alegacionModule from "@/store/modules/alegacion-module";
import { alegaciones_lote } from "@/shared/dtos/alegaciones_lote";
import { alegacion_historico } from "@/shared/dtos/alegacion_historico";

@Component({
  components: {},
})
export default class alegaciones_respuesta_token extends Vue {
  public cargando: boolean = false;
  public guardando: boolean = false;
  public error: string | null = null;
  public toastVisible: boolean = false;
  public toastMessage: string = "";
  public toastType: "success" | "error" = "success";

  get lote(): alegaciones_lote {
    return alegaciones_loteModule.lote;
  }

  get alegaciones(): alegacion_historico[] {
    return alegacionModule.alegaciones_historico;
  }

  get yaRespondido(): boolean {
    // El lote ya fue respondido si el estado no es PENDIENTE o si tiene fecha de respuesta
    if (!this.lote) return false;
    const estadosRespondidos = ["ACEPTADA", "DISCREPANCIA", "PARCIAL"];
    return (
      estadosRespondidos.includes(this.lote.estado_lote) &&
      !!(this.lote as any).fecha_respuesta
    );
  }

  public mounted() {
    this.cargarDatos();
  }

  public async cargarDatos() {
    this.cargando = true;
    this.error = null;

    try {
      let token: string | null = null;

      if (this.$route && this.$route.params && this.$route.params.token) {
        token = this.$route.params.token as string;
      } else if (this.$route && this.$route.query && this.$route.query.token) {
        token = this.$route.query.token as string;
      }

      if (!token) {
        this.error = "No se ha proporcionado un token válido en la URL.";
        this.cargando = false;
        return;
      }

      // 1) Cargar lote por token
      await alegaciones_loteModule.getLoteByToken(token);

      const lote = this.lote;

      if (!lote || !lote.id) {
        this.error =
          "No se ha encontrado información de alegaciones para este token.";
        this.cargando = false;
        return;
      }

      // 2) Cargar alegaciones del lote
      await alegacionModule.getAlegacionesByLote(lote.id);

      // Si alguna alegación viene sin estado, la inicializamos a ACEPTADA por defecto
      for (let i = 0; i < this.alegaciones.length; i++) {
        const a = this.alegaciones[i];
        if (!a.estado_respuesta || a.estado_respuesta === "") {
          a.estado_respuesta = "ACEPTADA";
        }
      }
    } catch (e) {
      this.error = "Se ha producido un error al cargar las alegaciones.";
    } finally {
      this.cargando = false;
    }
  }

  public formatearFecha(valor: any): string {
    if (!valor) {
      return "";
    }

    // Si es string tipo ISO
    if (typeof valor === "string") {
      const fecha = new Date(valor);
      if (isNaN(fecha.getTime())) {
        return valor;
      }
      return (
        this.dosDigitos(fecha.getDate()) +
        "/" +
        this.dosDigitos(fecha.getMonth() + 1) +
        "/" +
        fecha.getFullYear() +
        " " +
        this.dosDigitos(fecha.getHours()) +
        ":" +
        this.dosDigitos(fecha.getMinutes())
      );
    }

    // Si ya es Date
    if (valor instanceof Date) {
      const fecha = valor as Date;
      return (
        this.dosDigitos(fecha.getDate()) +
        "/" +
        this.dosDigitos(fecha.getMonth() + 1) +
        "/" +
        fecha.getFullYear() +
        " " +
        this.dosDigitos(fecha.getHours()) +
        ":" +
        this.dosDigitos(fecha.getMinutes())
      );
    }

    return valor.toString();
  }

  public dosDigitos(num: number): string {
    return num < 10 ? "0" + num : num.toString();
  }

  public async guardarRespuestas() {
    if (!this.alegaciones || this.alegaciones.length === 0) {
      return;
    }

    this.guardando = true;
    this.error = null;

    try {
      // 1) Guardar alegación por alegación
      for (let i = 0; i < this.alegaciones.length; i++) {
        const a = this.alegaciones[i];

        // Medio de autorización: usuario logueado vía enlace
        if (
          !a.medio_autorizacion ||
          a.medio_autorizacion === "" ||
          a.medio_autorizacion === "NO_RESPONDIDA"
        ) {
          a.medio_autorizacion = "USUARIO_LOGUEADO";
        }

        await alegacionModule.modificarAlegacion(a);
      }

      // 2) Actualizar el estado global del lote según las respuestas
      const lote = this.lote;
      if (lote && lote.id) {
        const tieneAceptadas = this.alegaciones.some(function(x) {
          return x.estado_respuesta === "ACEPTADA";
        });
        const tieneDiscrepancias = this.alegaciones.some(function(x) {
          return x.estado_respuesta === "DISCREPANCIA";
        });

        if (tieneAceptadas && !tieneDiscrepancias) {
          lote.estado_lote = "ACEPTADA";
        } else if (!tieneAceptadas && tieneDiscrepancias) {
          lote.estado_lote = "DISCREPANCIA";
        } else {
          lote.estado_lote = "PARCIAL";
        }

        // Fecha de respuesta
        (lote as any).fecha_respuesta = new Date();

        await alegaciones_loteModule.modificarLote(lote);
      }

      this.showToast(
        "Tus respuestas se han guardado correctamente.",
        "success"
      );
    } catch (e) {
      this.showToast(
        "Se ha producido un error al guardar tus respuestas.",
        "error"
      );
      this.error = "Se ha producido un error al guardar tus respuestas.";
    } finally {
      this.guardando = false;
    }
  }

  public showToast(message: string, type: "success" | "error" = "success") {
    this.toastMessage = message;
    this.toastType = type;
    this.toastVisible = true;

    // Auto-hide after 5 seconds
    setTimeout(() => {
      this.hideToast();
    }, 5000);
  }

  public hideToast() {
    this.toastVisible = false;
  }
}
